import { withCompInfo } from '@wix/editor-elements-integrations'
import { AbsoluteLayout, SingleLayoutData } from '@wix/thunderbolt-becky-types'
import { BackToTopButtonCss, BackToTopButtonDefinition } from './BackToTopButton'
import { getHeightCSS, getWidthCSS } from '@wix/editor-elements-common-utils'

const getLayoutDimension = (
	key: 'width' | 'height',
	skin: BackToTopButtonDefinition['skin'],
	compLayout: Partial<AbsoluteLayout>,
	compSingleLayout?: SingleLayoutData
) => {
	const defaultSize = 44
	const isLegacy = skin === 'BackToTopButtonSkin'
	const converterFunction = key === 'width' ? getWidthCSS : getHeightCSS
	return isLegacy ? `${defaultSize}px` : converterFunction(compLayout, compSingleLayout) ?? `${defaultSize}px`
}
export const css = withCompInfo<BackToTopButtonCss, BackToTopButtonDefinition>()(
	// @ts-ignore
	['compLayout', 'compSingleLayout', 'skin', 'compDesign', 'siteWidth', 'isOneDocMigrated'],
	// @ts-ignore
	({ compLayout, compSingleLayout, skin, compDesign, siteWidth, isOneDocMigrated }) => {
		const width = getLayoutDimension('width', skin, compLayout, compSingleLayout)
		const height = getLayoutDimension('height', skin, compLayout, compSingleLayout)
		const position = `calc((100% - ${siteWidth}px) / 2)`
		const opacityValue = compDesign?.shapeStyle?.opacity
		const opacity = typeof opacityValue === 'number' ? opacityValue : 1
		const bottomMargin = compLayout.docked ? compLayout.docked.bottom?.px : 87
		const rightMargin = compLayout.docked ? compLayout.docked.right?.px : 0
		const leftMargin = compLayout.docked ? compLayout.docked.left?.px : 0

		return {
			'--icon-opacity': opacity,
			...(!isOneDocMigrated && {
				position: 'fixed',
				bottom: `${bottomMargin}px`,
				width,
				height,
				...(typeof rightMargin !== 'undefined' && { 'margin-right': `${rightMargin}px`, right: position }),
				...(typeof leftMargin !== 'undefined' && { 'margin-left': `${leftMargin}px`, left: position }),
			}),
		}
	}
)
